import React, { ReactElement } from 'react';
import * as styles from "./styles.module.scss";

const ReadOnlyHeader = (props:{className?:string}):ReactElement => {
    return (<div className={`${styles.readOnlyHeader} ${props.className}`}>This budget has been locked from edits. Contact your system admin if
        you have questions.</div>);
};

export default ReadOnlyHeader;
